export default [
  {
    url: "/contratos",
    name: "Contratos",
    slug: "contratos",
    icon: "FileTextIcon",
    permission: "gerenciar contratos"
  },
  {
    url: "/clientes",
    name: "Clientes",
    slug: "clientes",
    icon: "UserIcon",
    permission: "gerenciar clientes"
  },
  {
    url: "/entidades",
    name: "Entidades",
    slug: "entidades",
    icon: "LayersIcon",
    permission: "gerenciar entidades"
  },
  {
    url: "/parceiros",
    name: "Parceiros",
    slug: "parceiros",
    icon: "ShieldIcon",
    permission: "gerenciar parceiros"
  },
  {
    url: "/usuarios",
    name: "Usuários",
    slug: "usuarios",
    icon: "UsersIcon",
    permission: "gerenciar usuarios"
  },
  {
    url: "/cobrancas",
    name: "Cobranças",
    slug: "cobrancas",
    icon: "DollarSignIcon",
    permission: "gerenciar cobrancas"
  },
  {
    url: "/analise-documentos",
    name: "Análise",
    slug: "analisarDocumentos",
    icon: "RefreshCwIcon",
    permission: "analisar documentos"
  }
];
